export const ADMIN_PASSWORD_MIN_LENGTH = 12;

const COMMON_WEAK_PASSWORDS = new Set([
  "password1234",
  "password12345",
  "qwerty123456",
  "welcome12345",
  "letmein12345",
  "changeme1234",
  "administrator",
  "123456789012",
]);

function isLegacyDefaultPattern(password: string): boolean {
  return /^admin\d{3,}$/i.test(password) || /^password\d*$/i.test(password);
}

function isRepeatedCharacterPassword(password: string): boolean {
  return /^(.)\1+$/.test(password);
}

function isNumericOnlyPassword(password: string): boolean {
  return /^\d+$/.test(password);
}

export function isCommonWeakAdminPassword(password: string): boolean {
  const normalized = password.trim().toLowerCase();
  return (
    COMMON_WEAK_PASSWORDS.has(normalized) ||
    isLegacyDefaultPattern(normalized) ||
    isRepeatedCharacterPassword(normalized) ||
    isNumericOnlyPassword(normalized)
  );
}

export function getAdminPasswordValidationError(password: string): string | null {
  if (!password || password.length < ADMIN_PASSWORD_MIN_LENGTH) {
    return `新密码长度不能少于${ADMIN_PASSWORD_MIN_LENGTH}位`;
  }

  if (isCommonWeakAdminPassword(password)) {
    return "新密码过于常见，请更换为不易猜测的密码";
  }

  return null;
}
